import React from 'react';
import { Box, Image, Text, Tooltip } from '@wix/design-system';
import { getClientImageURL, isExternalDashboard } from '../../..';
import { ExternalLinkSmall } from '@wix/wix-ui-icons-common';
import { AppBadge } from '../app-badge/app-badge';
import { useTranslation } from '../../../hooks/use-translation';
export function AppIntro(props) {
    const { app, bundleApps, isActionRequiredApp, siteIsPremium, siteIsBusinessFirstSite, } = props;
    const appName = app?.appInfo?.name;
    const appIconSrc = app?.appInfo?.icon;
    const shouldShowExternalSign = isExternalDashboard(app) && !isActionRequiredApp;
    const shouldShowBadge = !isActionRequiredApp;
    const planName = app?.premiumInfo?.planName;
    const shouldShowPlanName = !isActionRequiredApp && app?.premiumInfo?.planName;
    return (React.createElement(Box, { align: "center", verticalAlign: "middle" },
        React.createElement("span", { style: {
                height: '36px',
                width: '36px',
                borderRadius: '6px',
                border: '1px solid rgb(240, 244, 247)',
                boxSizing: 'border-box',
            } },
            React.createElement(Image, { width: 36, height: 36, src: getClientImageURL(appIconSrc, {
                    originalWidth: 1000,
                    originalHeight: 1000,
                    toWidth: 36,
                    toHeight: 36,
                }) })),
        React.createElement(Box, { direction: "vertical", marginTop: "-4px" },
            React.createElement(Box, { marginLeft: "12px", direction: "horizontal", dataHook: appName, align: "space-between" },
                React.createElement(Box, { direction: "vertical" },
                    React.createElement(Box, { direction: "horizontal" },
                        React.createElement(Text, { size: "medium", weight: "bold", skin: "standard" }, appName),
                        shouldShowExternalSign && (React.createElement(Box, { marginLeft: "2px", marginTop: "4px" },
                            React.createElement(ExternalAppSign, null))),
                        shouldShowBadge && (React.createElement(Box, { marginLeft: "6px", marginTop: "2px" },
                            React.createElement(AppBadge, { app: app, siteIsPremium: siteIsPremium, siteIsBusinessFirstSite: siteIsBusinessFirstSite, bundleApps: bundleApps })))),
                    shouldShowPlanName && (React.createElement(Box, { marginTop: "-2px" },
                        React.createElement(PlanName, { planName: planName }))))))));
}
export function ExternalAppSign() {
    const t = useTranslation();
    return (React.createElement(Tooltip, { content: t('manage-apps.app-card.app-intro.external-new') },
        React.createElement(ExternalLinkSmall, { "data-hook": "external-sign" })));
}
export function PlanName({ planName }) {
    const t = useTranslation();
    return (React.createElement(Text, { secondary: true, size: "tiny" }, t('manage-apps.app-card.app-intro.plan-text', { planeName: planName })));
}
//# sourceMappingURL=app-intro.js.map